"use client"

import { Fragment, useEffect, useState, useRef } from "react"
import NavbarVertical from "./navbars/NavbarVertical"
// import NavbarTop from "./navbars/NavbarTop"
import { useDispatch, useSelector } from "react-redux"
import { getUserAction } from "../../services/action/authentication"
import { useNavigate } from "react-router-dom"
import ShowCallHippo from "./call-hippo/ShowCallHippo"
import PushNotificationApp from "../../PushNotificationApp"
import ExpertProfileModal from "../../view/experts/profile/ExpertProfileModal"
import UpdateUserStatus from "./update-user-status/UpdateUserStatus"
import { handlePopupModalAction } from "../../services/action/event"
import MobileSidebar from "./navbars/MobileSidebar"
import QuickMenu from "./QuickMenu"

const DashboardLayout = (props) => {
  const [isMobile, setIsMobile] = useState(false)
  const { user } = useSelector((state) => state.authenticationReducer)
  const { isOpenSidebar } = useSelector((state) => state.eventReducer)
  const wrapperRef = useRef(null)

  // Check if the device is mobile
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 1024)
    }

    // Initial check
    checkIfMobile()

    // Add event listener for window resize
    window.addEventListener("resize", checkIfMobile)

    // Cleanup
    return () => window.removeEventListener("resize", checkIfMobile)
  }, [])

  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(
      getUserAction({
        hideError: true,
        errorCb: () => {
          localStorage.clear()
          navigate("/")
        },
      }),
    )
  }, [dispatch, navigate])

  // Add click outside handler to close flyout menus
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        // No action needed here - sidebar state is managed by Redux
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    user && (
      <Fragment>
        {user?.userType === "EXPERT" && <ExpertProfileModal />}
        <UpdateUserStatus />
        <QuickMenu/>
        <div ref={wrapperRef}>
          {/* Mobile overlay when sidebar is open */}
          {isMobile && isOpenSidebar && (
            <div
              className="fixed inset-0 bg-black bg-opacity-50 z-40"
              onClick={() => dispatch(handlePopupModalAction({ isOpenSidebar: false }))}
            />
          )}

          {user?.isAccessCallHippo && <ShowCallHippo />}
          {(user?.userType === "ADMIN" ||
            user?.userType === "SUPER_ADMIN" ||
            user?.userType === "OPERATOR" ||
            user?.userType === "MANAGER") && <PushNotificationApp />}
            <Fragment>
          {isMobile? <MobileSidebar/>: <NavbarVertical showMenu={isOpenSidebar} />}
          </Fragment>
          <div
            className="transition-all duration-300 ease-in-out"
            style={{
              marginLeft: isMobile ? "0" : isOpenSidebar ? "250px" : "66px",
            }}
          >
            <div className="pl-0">{props.children}</div>
          </div>
        </div>
      </Fragment>
    )
  )
}

export default DashboardLayout

